module.exports = __webpack_public_path__ + "img/m_cio_banner_right.35931beb.png";